import React from 'react';
import { Collapse } from 'antd';
import './StyledCollapsePanel.css';

const StyledCollapsePanel = ({ children, ...props }) => {
  return <Collapse.Panel {...props}>{children}</Collapse.Panel>;
};
export default StyledCollapsePanel;
